function isTruthyAttr(value) {
  const normalized = (value || '').trim().toLowerCase();
  return normalized === 'true' || normalized === '1';
}

function emptyWidgetConfig() {
  return {
    eventId: '',
    couponCode: '',
    initialView: 'register',
    guestEmail: '',
    trackVisits: true,
  };
}

function readHostSearchParams() {
  if (typeof window === 'undefined') {
    return new URLSearchParams();
  }
  try {
    return new URLSearchParams(window.location.search);
  } catch {
    return new URLSearchParams();
  }
}

function normalizeWidgetView(value) {
  return (value || '').trim().toLowerCase() === 'manage' ? 'manage' : 'register';
}

function readGuestEmail(element, searchParams) {
  const fromQuery = (searchParams.get('email') || '').trim();
  if (fromQuery) {
    return fromQuery;
  }
  return (element?.getAttribute?.('data-meo-guest-email') || '').trim();
}

function readCouponCode(element, searchParams) {
  const fromQuery = (searchParams.get('coupon') || '').trim();
  if (fromQuery) {
    return fromQuery;
  }
  return (
    element?.getAttribute?.('data-meo-coupon')
    || element?.getAttribute?.('data-coupon')
    || ''
  ).trim();
}

function readInitialView(element, searchParams) {
  const fromQuery = (searchParams.get('view') || '').trim().toLowerCase();
  if (fromQuery === 'manage' || fromQuery === 'register') {
    return fromQuery;
  }
  return normalizeWidgetView(element?.getAttribute?.('data-meo-view') || 'register');
}

/**
 * Read embed config from a host container element's data attributes.
 *
 * Supported attributes:
 * - data-event-id / data-meo-event-id — required event id
 * - data-meo-coupon / data-coupon — optional coupon code
 * - data-meo-view — "register" (default) or "manage"
 * - data-meo-guest-email — optional guest email prefill for manage sign-in (MER-612)
 * - data-meo-preview — skip page-view / registration attribution (dashboard live preview)
 *
 * Host-page query params (`source`, `campaign`, `utm_*`) are captured from
 * `window.location` for Insights tracking (MER-578). Payment-reminder deep
 * links (MER-611 / MER-612) also use `view=manage` and `email` — those
 * override the matching data attributes so a fixed embed can open manage
 * with the guest's email prefilled. Coupon share links (MER-672) use
 * `?coupon=` on the organizer event site the same way.
 */
export function readWidgetConfig(element) {
  if (!element?.getAttribute) {
    return emptyWidgetConfig();
  }

  const searchParams = readHostSearchParams();

  const eventId = (
    element.getAttribute('data-event-id')
    || element.getAttribute('data-meo-event-id')
    || ''
  ).trim();

  const couponCode = readCouponCode(element, searchParams);
  const initialView = readInitialView(element, searchParams);
  const guestEmail = readGuestEmail(element, searchParams);
  const trackVisits = !isTruthyAttr(element.getAttribute('data-meo-preview'));

  return { eventId, couponCode, initialView, guestEmail, trackVisits };
}

/**
 * Containers eligible for auto-mount.
 * Prefer #meo-widget or an explicit data-meo-widget marker — do not mount
 * every element that happens to carry a data-event-id.
 */
export const WIDGET_HOST_SELECTOR = [
  '#meo-widget[data-event-id]',
  '#meo-widget[data-meo-event-id]',
  '[data-meo-widget][data-event-id]',
  '[data-meo-widget][data-meo-event-id]',
].join(', ');
